<ng-container *ngIf="!isNewEDPScoreboard; else tournament">
    <div class="event-name">
        <ms-favourite-event-toggle class="participant-favourite" [event]="event" />
        <span class="participant-name">{{ event.name }} </span>
    </div>
    <div *ngIf="score && score.final && score.current && score.type && event.sport.id === sportType.Cycling">
        <span class="score" *ngIf="score.type === 'km'">{{ score.current }}/{{ score.final }}{{ score.type }}</span>
        <span class="score" *ngIf="score.type === 'Stage'">{{ sitecoreEventDetails.eventDetails.Stage }} {{ score.current }}/{{ score.final }}</span>
        <span class="score" *ngIf="score.type === 'Lap'">{{ sitecoreEventDetails.eventDetails.Lap }} {{ score.current }}/{{ score.final }}</span>
    </div>
    <div class="event-live" *ngIf="event.sport.id === sportType.Golf || !(score && score.final && score.current && score.type)">
        <span>{{ sitecore.freeBetOverview.messages?.Live }}</span>
    </div>
</ng-container>

<ng-template #tournament>
    <div class="event-header-live">
        <i class="live-icon"></i>
        <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" [eventId]="event.sport.id" />
    </div>
    <div class="participant-info">
        <ms-competition-logo
            *ngIf="showCompetitionLogo; else defaultImage"
            [sportId]="event.sport.id"
            [leagueId]="event.league.id"
            [imageProfile]="event.league.imageProfile" />
        <ng-template #defaultImage>
            <ms-participant-image
                class="participant-image"
                [participantImage]="event.league.imageProfile"
                [sportId]="event.sport.id"
                [showFallback]="isNewEDPScoreboard" />
        </ng-template>
        <div class="participant-name">
            {{ event.name }}
            <span class="participant-country">{{ event.league.name }}</span>
        </div>
    </div>
</ng-template>
